export const sendSignUpPageViewEvent = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'sign_up_page_view',
    })
  }
}

export const sendUserSignUpEvent = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'user_sign_up',
    })
  }
}
